import { LateFormAlertDefinition } from './LateFormAlertDefinition';
import { LowAverageRatingAlertDefinition } from './LowAverageRatingAlertDefinition';
import { SpecificRatingAlertDefinition } from './SpecificRatingAlertDefinition';
import { TrainingTimeAlertDefinition } from './TrainingTimeAlertDefinition';
import { PhaseLengthAlertDefinition } from './PhaseLengthAlertDefinition';
import { PhaseAdditionalHoursAlertDefinition } from './PhaseAdditionalHoursAlertDefinition';
import { LateQuizAlertDefinition } from './LateQuizAlertDefinition';
import { IncidentWarningAlertDefinition } from './IncidentWarningAlertDefinition';
import { AclItemApiModel } from '../../AclItemApiModel';
import { AlertType } from '@app/shared/enums';
import { NRTAlertDefinition } from './NRTAlertDefinition';
import { UpcomingFormAlertDefinition } from './UpcomingFormAlertDefinition';

export class AlertApiModel {
  public Id: string;
  public Type: AlertType;
  public Name = '';
  public IsActive = false;
  public ACL: AclItemApiModel[] = [];
  public PhaseIds = new Array<number>();
  public Definition = {} as
    | LateFormAlertDefinition
    | LowAverageRatingAlertDefinition
    | TrainingTimeAlertDefinition
    | SpecificRatingAlertDefinition
    | PhaseLengthAlertDefinition
    | PhaseAdditionalHoursAlertDefinition
    | LateQuizAlertDefinition
    | IncidentWarningAlertDefinition
    | NRTAlertDefinition
    | UpcomingFormAlertDefinition;
  public NotifyByEmail = false;
  public NotifyOnDashboard = false;

  constructor(type?: AlertType) {
    this.Type = type;
  }

  public deserialize(data: Object): AlertApiModel {
    Object.assign(this, data);
    this.ACL = this.ACL.map((x) => new AclItemApiModel().deserialize(x));
    return this;
  }
}
